require('../vendor/aws-sdk/index.js');
require('../vendor/amazon-cognito/index.js');

module.exports = window.AWS;
